module.exports = __webpack_public_path__ + "static/custom-domain-f790b280e0c385df9e502266ca86ad84.jpg";